// extracted by mini-css-extract-plugin
export default {"container":"CallCenterCustomerIssues_container__q2d5m"};